module.exports = __webpack_public_path__ + "img/game7.a92030d7.png";